export const accountViews = {
  botConfig: {
    breadcrumb: {
      listings: "الإعلانات",
      current: "وكيل الذكاء الاصطناعي",
    },
    loading: "جارٍ تحميل الإعدادات...",
    retry: "إعادة المحاولة",
    loadError: "حدث خطأ أثناء تحميل الإعدادات.",
    units: "{count} وحدة | {count} وحدات",
    faqsLabel: "الأسئلة الشائعة",
    unitFallback: "وحدة",
    active: "نشط",
    inactive: "غير نشط",
    botWhatsapp: "روبوت واتساب",
    otaIa: "ذكاء اصطناعي OTA",
    saving: "جارٍ الحفظ...",
    cancel: "إلغاء",
    assistant: {
      title: "مساعد واتساب",
      desc: "فعّل الروبوت التلقائي للرد على ضيوفك عبر واتساب.",
    },
    ota: {
      title: "ذكاء اصطناعي OTA",
      desc: "يرد تلقائيًا على رسائل Booking.com وAirbnb ومنصات OTA الأخرى.",
      warn: "فعّل مساعد واتساب أولًا",
    },
    botName: {
      title: "اسم المساعد",
      desc: "الاسم الذي سيقدّم به الروبوت نفسه لضيوفك.",
      empty: "لا يوجد اسم مُعيَّن",
      edit: "تعديل",
      placeholder: "مثال: مريم، صوفيا، المساعد الافتراضي...",
      save: "حفظ",
    },
    faqs: {
      title: "الأسئلة الشائعة",
      desc: "تنطبق هذه الأسئلة الشائعة على <strong>جميع وحدات</strong> هذا الإعلان. سيستخدمها الروبوت للرد على ضيوفك.",
      add: "سؤال شائع جديد",
      emptyText: "لا توجد لديك أسئلة شائعة مُعدّة بعد.",
      addFirst: "+ إضافة أول سؤال شائع",
      answerEmpty: "لا توجد إجابة",
      editTitle: "تعديل",
      deleteTitle: "حذف",
      questionLabel: "السؤال",
      answerLabel: "الإجابة",
      questionPlaceholder: "اكتب السؤال...",
      answerPlaceholder: "اكتب الإجابة التي سيراها الضيف...",
      saveChanges: "حفظ التغييرات",
    },
    addModal: {
      title: "سؤال شائع جديد",
      questionLabel: "السؤال",
      questionPlaceholder: "مثال: ما موعد تسجيل الوصول؟",
      answerLabel: "الإجابة",
      answerPlaceholder: "مثال: تسجيل الوصول من الساعة 15:00. إذا وصلت مبكرًا، يمكنك ترك الأمتعة...",
      submit: "إضافة سؤال شائع",
    },
    deleteModal: {
      title: "حذف السؤال",
      confirm: "هل أنت متأكد أنك تريد حذف هذا السؤال الشائع؟",
      deleting: "جارٍ الحذف...",
      submit: "نعم، احذف",
    },
    types: {
      apartment: "شقة",
      house: "منزل",
      villa: "فيلا",
      hotel: "فندق",
      room: "غرفة",
      studio: "استوديو",
      default: "إقامة",
    },
    toast: {
      botOn: "تم تفعيل الروبوت",
      botOff: "تم إيقاف الروبوت",
      botError: "حدث خطأ أثناء تغيير حالة الروبوت",
      otaOn: "تم تفعيل ذكاء اصطناعي OTA",
      otaOff: "تم إيقاف ذكاء اصطناعي OTA",
      otaError: "حدث خطأ أثناء تغيير حالة ذكاء اصطناعي OTA",
      nameUpdated: "تم تحديث اسم المساعد",
      nameError: "حدث خطأ أثناء حفظ الاسم",
      faqAdded: "تمت إضافة السؤال الشائع بنجاح",
      faqAddError: "حدث خطأ أثناء حفظ السؤال الشائع",
      faqUpdated: "تم تحديث السؤال الشائع",
      faqUpdateError: "حدث خطأ أثناء تحديث السؤال الشائع",
      faqDeleted: "تم حذف السؤال الشائع",
      faqDeleteError: "حدث خطأ أثناء حذف السؤال الشائع",
    },
  },

  listingIndex: {
    title: "الإعلانات",
    subtitle: "أدر الإعدادات المركزية لكل إعلان من إعلاناتك.",
    countFiltered: "{shown} من {total} إعلانات",
    count: "{count} إعلان | {count} إعلانات",
    searchPlaceholder: "ابحث بالاسم أو المعرّف أو النوع…",
    clear: "مسح",
    loadErrorTitle: "تعذّر تحميل أماكن الإقامة",
    retry: "إعادة المحاولة",
    emptyTitle: "لا توجد إعلانات",
    emptyText: "لا توجد لديك أي إعلانات مسجّلة بعد.",
    noResultsTitle: 'لا توجد نتائج لـ "{query}"',
    noResultsText: "جرّب اسمًا أو معرّفًا أو نوع إعلان آخر.",
    clearSearch: "مسح البحث",
    dragSearchHint: "امسح البحث لإعادة الترتيب",
    dragHint: "اسحب لإعادة الترتيب",
    units: "{count} وحدة | {count} وحدات",
    botActiveTitle: "روبوت GPT نشط",
    channelTitle: "متصل بـ Channex",
    icalTitle: "مزامنة iCal",
    editTitle: "تعديل الاسم",
    modal: {
      title: "تعديل اسم الإعلان",
      nameLabel: "اسم الإعلان",
      namePlaceholder: "مثال: شقق كوستا سول",
      orderLabel: "ترتيب الإعلان",
      info: "يجمع <strong>الإعلان</strong> جميع العقارات التي تشترك في الإعدادات ورسائل الترحيب والسياسات نفسها. الاسم الذي تحدده هنا سيميّز المجموعة في اللوحة وفي قنوات التوزيع المتصلة.",
      cancel: "إلغاء",
      save: "حفظ التغييرات",
    },
    types: {
      apartment: "شقة",
      house: "منزل",
      villa: "فيلا",
      hotel: "فندق",
      room: "غرفة",
      studio: "استوديو",
      default: "إقامة",
    },
    toast: {
      connectionError: "خطأ في الاتصال.",
      reorderSuccess: "تم تحديث الترتيب بنجاح.",
      reorderError: "تعذّر تحديث ترتيب الإعلانات.",
      saveSuccess: "تم تحديث الإعلان بنجاح.",
      saveError: "حدث خطأ أثناء حفظ الإعلان.",
    },
  },

  unitDetail: {
    back: "العودة إلى الإعلان",
    eyebrow: "وحدة",
    save: "حفظ",
    cancel: "إلغاء",
    editNameTitle: "تعديل اسم الوحدة",
    nameFallback: "وحدة",
    types: {
      apartment: "شقة",
      house: "منزل",
      villa: "فيلا",
      hotel: "فندق",
      camping: "تخييم",
      room: "غرفة",
      studio: "استوديو",
      default: "إقامة",
    },
    deleteLink: "حذف الوحدة...",
    dangerNoteBefore: "يحذف الوحدة من الإعلان",
    dangerNoteAfter: "من WACheckin. لا يمكن التراجع عن هذا الإجراء.",
    cards: {
      description: { title: "الوصف", sub: "تفاصيل الوحدة" },
      capacity: { title: "السعة", sub: "الضيوف والأسرّة" },
      services: { title: "التجهيزات ووسائل الراحة", sub: "ما يقدمه، مع الصور" },
      rules: { title: "المواعيد", sub: "مواعيد الوصول والمغادرة" },
      arrival: { title: "تعليمات الوصول", sub: "كيفية الوصول والدخول · مع وقت الإرسال" },
      smartlocks: { title: "الأقفال والدخول", sub: "كيف يدخل الضيف" },
      checkout: { title: "رسالة المغادرة", sub: "تذكير بالمغادرة · قالب" },
      scheduled: { title: "الرسائل المجدولة", sub: "رسائل لهذه الوحدة فقط" },
      unitFaq: { title: "الأسئلة والأجوبة", sub: "خاصة بهذه الوحدة للوكيل", badge: "ذكاء اصطناعي" },
      welcome: { title: "رسالة الترحيب", sub: "رسالة خاصة بهذه الوحدة" },
      stockExtra: {
        title: "المخزون الإضافي",
        subOff: "معطّل · يستقبل حجوزات وحدة أخرى",
        subOn: "يدعم {name}",
        subOnGeneric: "يدعم وحدة أخرى",
        badge: "مفعّل",
      },
    },
    sections: {
      aiOnlyLabel: "الأسئلة الشائعة للوحدة",
      aiOnlyDesc: "سيعطيها الوكيل الأولوية عند خدمة ضيف يقيم في هذه الوحدة.",
      specificLabel: "إعدادات خاصة بهذه الوحدة",
      detailLabel: "فصّل هذه الوحدة",
      detailDesc: "معلومات إضافية نستخدمها للحجوزات المباشرة ولتغذية وكيل الذكاء الاصطناعي.",
    },
    stockExtra: {
      title: "المخزون الإضافي",
      intro: "في Booking أو Airbnb قد يكون لديك إعلان واحد فقط يتسع لعدة شقق: وبما أنه لا يمكن ربط سوى وحدة واحدة، تُرسل القناة كل تلك الحجوزات إلى الوحدة نفسها فتتكدس في حجز زائد.",
      how: "إذا جعلت هذه الوحدة مخزونًا إضافيًا لوحدة أخرى، فإن الحجوزات التي تتعارض مع الوحدة الرئيسية تُحفظ هنا ويتم إبلاغ القناة لتظهر عندها أيضًا في هذه الوحدة.",
      purpose: "إنها أداة انتقال: تُفعّل لنقل ما سبق أن بِعته في القناة، وتُطفأ عندما يصبح لكل شقة إعلانها الخاص.",
      loading: "جارٍ التحميل...",
      activeLabel: "يدعم {name}",
      activeHint: "حجوزات القناة التي تتعارض مع {name} تُحفظ في هذه الوحدة.",
      activeBadge: "مفعّل",
      otherUnit: "وحدة أخرى",
      warnTitle: "لا تفعّله إذا كان لكل شقة إعلانها الخاص المربوط في القناة:",
      warnText: "فهناك ترسل القناة كل حجز إلى وحدته، ومع تفعيل المخزون الإضافي قد ينتهي الحجز في شقة غير التي بِعتها.",
      principalOf: "وحدات أخرى تعتمد على هذه الوحدة بالفعل:",
      chooseLabel: "الوحدة الرئيسية",
      chooseDesc: "اختر الوحدة التي ستُحفظ حجوزاتها في «{unit}» عند تعارضها فيما بينها.",
      noCandidates: "لا توجد وحدة أخرى لدعمها في هذا الإعلان.",
      activate: "تفعيل المخزون الإضافي",
      change: "تغيير الوحدة الرئيسية",
      saving: "جارٍ الحفظ...",
      removeBtn: "إزالة المخزون الإضافي",
      removeNote: "الحجوزات المحفوظة هنا لا تُنقل: تبقى في هذه الوحدة.",
      errorCarga: "تعذّر تحميل إعدادات المخزون الإضافي. إذا كنت قد حدّثت للتو، جرّب إعادة تحميل الصفحة.",
      reintentar: "إعادة المحاولة",
      toastLoadError: "تعذّر تحميل المخزون الإضافي.",
      toastSaveError: "تعذّر حفظ المخزون الإضافي.",
    },
    toast: {
      nameEmpty: "لا يمكن أن يكون الاسم فارغًا",
      nameUpdated: "تم تحديث الاسم",
      nameError: "تعذّر تحديث الاسم",
    },
  },

  miCuenta: {},
};
